/**
 * Vertex360 AI service API — timesheet anomaly analysis only.
 * Reads (table flags, full report drawer) use Laravel (get-worker-timesheets, URL_ROSTERING_TIMESHEET_AI_ANOMALY).
 * Wallet balance / usage history remain on Laravel (URL_SP_AI_*).
 */
import { aiClient, aiStreamPost } from "./aiClient";
import {
  URL_AI_TIMESHEET_ANOMALY_CHECK_BATCH,
  URL_AI_TIMESHEET_ANOMALY_CHECK_BATCH_STREAM,
} from "./URL";

export const aiApi = {
  /**
   * Batch anomaly analysis (web multi-select).
   * POST /api/v1/timesheets/anomaly-check
   * Parallel LLM per id; one usage log; one wallet debit.
   *
   * @param {number[]} timesheetIds
   */
  runTimesheetAnomalyCheckBatch(timesheetIds, options = {}) {
    return aiClient.post(
      URL_AI_TIMESHEET_ANOMALY_CHECK_BATCH,
      { timesheet_ids: timesheetIds },
      options
    );
  },

  /**
   * Streamed batch analyse with real-time SSE progress (15 min timeout).
   * POST /api/v1/timesheets/anomaly-check/stream
   */
  runTimesheetAnomalyCheckBatchStream(timesheetIds, options = {}) {
    return aiStreamPost(
      URL_AI_TIMESHEET_ANOMALY_CHECK_BATCH_STREAM,
      { timesheet_ids: timesheetIds },
      options
    );
  },
};
